import React, { useState } from 'react';
import { ShieldCheckIcon, PlusCircleIcon, CheckIcon, XIcon } from 'lucide-react';
export function MachineStatus() {
  const [gusseStatus, setGusseStatus] = useState<boolean | null>(null);
  const [rostStatus, setRostStatus] = useState<boolean | null>(null);
  const [gusseBemerkung, setGusseBemerkung] = useState('');
  const [rostBemerkung, setRostBemerkung] = useState('');
  const [rezeptur1Bemerkung, setRezeptur1Bemerkung] = useState('');
  const [rezeptur2Bemerkung, setRezeptur2Bemerkung] = useState('');
  const [showGusseBemerkung, setShowGusseBemerkung] = useState(false);
  const [showRostBemerkung, setShowRostBemerkung] = useState(false);
  const [showRezeptur1Bemerkung, setShowRezeptur1Bemerkung] = useState(false);
  const [showRezeptur2Bemerkung, setShowRezeptur2Bemerkung] = useState(false);
  const StatusIndicator = ({
    status
  }: {
    status: boolean | null;
  }) => <div className={`w-2 h-2 rounded-full ${status === null ? 'bg-gray-300' : status ? 'bg-green-500' : 'bg-red-500'}`} data-id="element-579" />;
  const QSKachel = ({
    title,
    status,
    setStatus,
    bemerkung,
    setBemerkung,
    showBemerkung,
    setShowBemerkung
  }: {
    title: string;
    status: boolean | null;
    setStatus: (status: boolean) => void;
    bemerkung: string;
    setBemerkung: (bemerkung: string) => void;
    showBemerkung: boolean;
    setShowBemerkung: (show: boolean) => void;
  }) => <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-580">
      <div className="flex items-center justify-between mb-4" data-id="element-581">
        <div className="flex items-center gap-2" data-id="element-582">
          <StatusIndicator status={status} data-id="element-583" />
          <h4 className="text-sm font-medium text-gray-800" data-id="element-584">{title}</h4>
        </div>
        <div className="flex gap-1.5" data-id="element-585">
          <button onClick={() => setStatus(true)} className={`px-3 py-1.5 text-xs font-medium rounded transition-colors ${status === true ? 'bg-green-100 text-green-700' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}`} data-id="element-586">
            <CheckIcon size={14} className="inline-block mr-1" data-id="element-587" />
            Ja
          </button>
          <button onClick={() => setStatus(false)} className={`px-3 py-1.5 text-xs font-medium rounded transition-colors ${status === false ? 'bg-red-100 text-red-700' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}`} data-id="element-588">
            <XIcon size={14} className="inline-block mr-1" data-id="element-589" />
            Nein
          </button>
        </div>
      </div>
      {!showBemerkung && !bemerkung && <button onClick={() => setShowBemerkung(true)} className="w-full py-1.5 px-3 text-xs text-gray-500 hover:text-gray-700 border border-dashed border-gray-200 rounded flex items-center justify-center gap-1.5" data-id="element-590">
          <PlusCircleIcon size={14} data-id="element-591" />
          Bemerkung
        </button>}
      {(showBemerkung || bemerkung) && <div className="space-y-1.5" data-id="element-592">
          <label className="block text-xs text-gray-500" data-id="element-593">Bemerkung</label>
          {showBemerkung ? <div className="flex gap-1.5" data-id="element-594">
              <input type="text" value={bemerkung} onChange={e => setBemerkung(e.target.value)} placeholder="Bemerkung eingeben..." className="flex-1 px-2 py-1 text-xs border rounded focus:outline-none focus:ring-1 focus:ring-blue-500" onKeyDown={e => {
          if (e.key === 'Enter') setShowBemerkung(false);
        }} data-id="element-595" />
              <button onClick={() => setShowBemerkung(false)} className="px-2 py-1 text-gray-400 hover:text-gray-600" data-id="element-596">
                <CheckIcon size={14} data-id="element-597" />
              </button>
            </div> : <div className="flex items-center justify-between group" data-id="element-598">
              <span className="text-xs text-gray-600" data-id="element-599">{bemerkung}</span>
              <button onClick={() => setShowBemerkung(true)} className="opacity-0 group-hover:opacity-100 transition-opacity px-1.5 py-1 text-gray-400 hover:text-gray-600" data-id="element-600">
                <PlusCircleIcon size={14} data-id="element-601" />
              </button>
            </div>}
        </div>}
    </div>;
  const RezepturKachel = ({
    title,
    values,
    bemerkung,
    setBemerkung,
    showBemerkung,
    setShowBemerkung
  }: {
    title: string;
    values: {
      label: string;
      value: string;
    }[];
    bemerkung: string;
    setBemerkung: (bemerkung: string) => void;
    showBemerkung: boolean;
    setShowBemerkung: (show: boolean) => void;
  }) => <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-602">
      <h4 className="text-sm font-medium text-gray-800 mb-3" data-id="element-603">{title}</h4>
      <div className="grid grid-cols-5 gap-2 mb-3" data-id="element-604">
        {values.map((item, index) => <div key={index} className="bg-gray-50 p-2 rounded border border-gray-200" data-id="element-605">
            <div className="text-[11px] text-gray-500 mb-1" data-id="element-606">{item.label}</div>
            <div className="text-xs font-medium text-gray-800" data-id="element-607">
              {item.value}
            </div>
          </div>)}
      </div>
      {!showBemerkung && !bemerkung && <button onClick={() => setShowBemerkung(true)} className="w-full py-1.5 px-3 text-xs text-gray-500 hover:text-gray-700 border border-dashed border-gray-200 rounded flex items-center justify-center gap-1.5" data-id="element-608">
          <PlusCircleIcon size={14} data-id="element-609" />
          Bemerkung
        </button>}
      {(showBemerkung || bemerkung) && <div className="space-y-1.5" data-id="element-610">
          <label className="block text-xs text-gray-500" data-id="element-611">Bemerkung</label>
          {showBemerkung ? <div className="flex gap-1.5" data-id="element-612">
              <input type="text" value={bemerkung} onChange={e => setBemerkung(e.target.value)} placeholder="Bemerkung eingeben..." className="flex-1 px-2 py-1 text-xs border rounded focus:outline-none focus:ring-1 focus:ring-blue-500" onKeyDown={e => {
          if (e.key === 'Enter') setShowBemerkung(false);
        }} data-id="element-613" />
              <button onClick={() => setShowBemerkung(false)} className="px-2 py-1 text-gray-400 hover:text-gray-600" data-id="element-614">
                <CheckIcon size={14} data-id="element-615" />
              </button>
            </div> : <div className="flex items-center justify-between group" data-id="element-616">
              <span className="text-xs text-gray-600" data-id="element-617">{bemerkung}</span>
              <button onClick={() => setShowBemerkung(true)} className="opacity-0 group-hover:opacity-100 transition-opacity px-1.5 py-1 text-gray-400 hover:text-gray-600" data-id="element-618">
                <PlusCircleIcon size={14} data-id="element-619" />
              </button>
            </div>}
        </div>}
    </div>;
  return <div className="bg-gray-50 rounded-lg p-6" data-id="element-620">
      <div className="flex items-center justify-between mb-6" data-id="element-621">
        <div className="flex items-center gap-2" data-id="element-622">
          <ShieldCheckIcon className="text-[#3498dd]" size={20} data-id="element-623" />
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-624">
            Granular & Ansätze
          </h3>
        </div>
        <div className="flex items-center gap-4 text-xs" data-id="element-625">
          <div className="flex items-center gap-1.5" data-id="element-626">
            <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-627" />
            <span className="text-gray-600" data-id="element-628">OK</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-629">
            <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-630" />
            <span className="text-gray-600" data-id="element-631">Nicht OK</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-632">
            <div className="w-2 h-2 rounded-full bg-gray-300" data-id="element-633" />
            <span className="text-gray-600" data-id="element-634">Nicht gesetzt</span>
          </div>
        </div>
      </div>
      <div className="space-y-6" data-id="element-635">
        <div data-id="element-636">
          <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-637">QS-Status</h4>
          <div className="grid grid-cols-2 gap-4" data-id="element-638">
            <QSKachel title="Güsse/Flecken" status={gusseStatus} setStatus={setGusseStatus} bemerkung={gusseBemerkung} setBemerkung={setGusseBemerkung} showBemerkung={showGusseBemerkung} setShowBemerkung={setShowGusseBemerkung} data-id="element-639" />
            <QSKachel title="Rostpakete in Hammermühle" status={rostStatus} setStatus={setRostStatus} bemerkung={rostBemerkung} setBemerkung={setRostBemerkung} showBemerkung={showRostBemerkung} setShowBemerkung={setShowRostBemerkung} data-id="element-640" />
          </div>
        </div>
        <div data-id="element-641">
          <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-642">Rezepturen</h4>
          <div className="grid grid-cols-2 gap-4" data-id="element-643">
            <RezepturKachel title="Rezeptur 1" values={[{
            label: 'Gran%',
            value: '0'
          }, {
            label: 'H₂O',
            value: '105kg'
          }, {
            label: 'Disp',
            value: '30kg'
          }, {
            label: 'Gran',
            value: '1365kg'
          }, {
            label: 'U/m',
            value: '900'
          }]} bemerkung={rezeptur1Bemerkung} setBemerkung={setRezeptur1Bemerkung} showBemerkung={showRezeptur1Bemerkung} setShowBemerkung={setShowRezeptur1Bemerkung} data-id="element-644" />
            <RezepturKachel title="Rezeptur 2" values={[{
            label: 'Gran%',
            value: '15'
          }, {
            label: 'H₂O',
            value: '95kg'
          }, {
            label: 'Disp',
            value: '25kg'
          }, {
            label: 'Gran',
            value: '1275kg'
          }, {
            label: 'U/m',
            value: '850'
          }]} bemerkung={rezeptur2Bemerkung} setBemerkung={setRezeptur2Bemerkung} showBemerkung={showRezeptur2Bemerkung} setShowBemerkung={setShowRezeptur2Bemerkung} data-id="element-645" />
          </div>
        </div>
      </div>
    </div>;
}